import { apiAuth } from './apiGroup/apiAuth'
import { apiProducts } from './apiGroup/apiProducts'
import { apiProductsParameters } from './apiGroup/apiProductsParameters'
import { apiUsers } from './apiGroup/apiUsers'
import { apiFiles } from './apiGroup/apiFiles'
import { apiDiscountCodes } from './apiGroup/apiDiscountCodes'
import { apiGeocoding } from './apiGroup/apiGeocoding'
import { apiLocations } from './apiGroup/apiLocations'
import { apiProductsSegments } from './apiGroup/apiProductsSegments'
import { apiUpsells } from './apiGroup/apiUpsells'
import { apiSegmentGroups } from './apiGroup/apiSegmentGroups'
import { apiOrders } from './apiGroup/apiOrders'
import { apiReservation } from './apiGroup/apiReservation'
import { apiRenteon } from './apiGroup/apiRenteon'
import { apiPagesCRM } from './apiGroup/apiPagesCRM'
import { apiCMSLocations } from './apiGroup/apiCMSLocations'
import { apiCMSLocationsContent } from './apiGroup/apiCMSLocationsContent'
import { apiNews } from './apiGroup/apiNews'
import { apiCurrencies } from './apiGroup/apiCurrencies'
import { apiGoogleRatings } from './apiGroup/apiGoogleRatings'
import { apiTrustpilotRatings } from './apiGroup/apiTrustpilotRatings'
import { apiBooking } from './apiGroup/apiBooking'
import { apiSpecialDailyOffers } from './apiGroup/apiSpecialDailyOffers'
import { apiSubpagesContent } from './apiGroup/apiSubpagesContent'
import { apiNip } from './apiGroup/apiNip'
import { apiContactForm } from './apiGroup/apiContactForm'
import { apiNewsletter } from './apiGroup/apiNewsletter'
import { apiAdvanceRatePeriods } from './apiGroup/apiAdvanceRatePeriods'
import { apiAuthors } from './apiGroup/apiAuthors'

export const ApiService = {
	...apiProducts,
	...apiAuth,
	...apiProductsParameters,
	...apiUsers,
	...apiFiles,
	...apiDiscountCodes,
	...apiGeocoding,
	...apiLocations,
	...apiProductsSegments,
	...apiUpsells,
	...apiSegmentGroups,
	...apiOrders,
	...apiReservation,
	...apiRenteon,
	...apiPagesCRM,
	...apiCMSLocations,
	...apiCMSLocationsContent,
	...apiNews,
	...apiCurrencies,
	...apiGoogleRatings,
	...apiTrustpilotRatings,
	...apiBooking,
	...apiSpecialDailyOffers,
	...apiSubpagesContent,
	...apiNip,
	...apiContactForm,
	...apiNewsletter,
	...apiAdvanceRatePeriods,
	...apiAuthors,
}
